import { render, staticRenderFns } from "./DataRecordListItemValue.vue?vue&type=template&id=532507fb&"
import script from "./DataRecordListItemValue.vue?vue&type=script&lang=js&"
export * from "./DataRecordListItemValue.vue?vue&type=script&lang=js&"
import style0 from "./DataRecordListItemValue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports